import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constants";
import { hideLoaderAction, showLoaderAction } from "./loaderAction";

const getDashboard = (filters = {}, setLoading) => async (dispatch) => {
    dispatch(showLoaderAction());
    if (setLoading) {
        setLoading(true);
    }
    const normalizedFilters = typeof filters === "number" ? { year: filters } : filters;
    const query = new URLSearchParams();

    Object.entries(normalizedFilters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            query.set(key, value);
        }
    });

    const res = await api("get", `${Constants.END_POINT.DASHBOARD}?${query.toString()}`);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.DASHBOARD,
                payload: res.data,
            });
        }
    }
    if (setLoading) {
        setLoading(false);
    }
    dispatch(hideLoaderAction());
};
const newOrdersCount = () => async (dispatch) => {
    const res = await api("get", Constants.END_POINT.NEW_ORDERS_COUNT);

    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.NEW_ORDERS_COUNT,
                payload: res.data,
            });
        }
    }
};

export { getDashboard, newOrdersCount };
